const loadingCount = ref(0);

export const isLoading = computed(() => loadingCount.value > 0);

export const start = () => {
  loadingCount.value += 1;
};

export const finish = () => {
  loadingCount.value = Math.max(0, loadingCount.value - 1);
};

export const finishAll = () => {
  loadingCount.value = 0;
};
